/* ClarityHit · sklep na jednej stronie, wersja bez efektów (2026-10-21): statyczny hero i nagłówki, zwykły przycisk zakupu.
   Zostają: oferta (wybór, zgoda, kasa), narzędzie z książki, formularz rozdziału, pasek zakupu, Szybkie wyjście, scena „Nitki”. Bez bibliotek. */
(function () {
  'use strict';
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var onView = function (el, fn, th) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); fn(); } }, { threshold: th || 0.4 });
    io.observe(el);
  };

  /* ---------- #16 Toasty ze stosem i swipe ---------- */
  var stack = $('[data-toasts]'), tsr = $('[data-toast-sr]');
  var ICO = {
    bag: '<path d="M5 8h14l-1.2 11.2a1.5 1.5 0 0 1-1.5 1.3H7.7a1.5 1.5 0 0 1-1.5-1.3z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/><path d="m9.6 14 1.7 1.7 3.2-3.4"/>',
    card: '<rect x="3" y="6" width="18" height="12" rx="2"/><path d="M3 10h18M7 15h3"/>',
    mail: '<rect x="3" y="6" width="18" height="13" rx="2"/><path d="M3.5 7l8.5 6 8.5-6"/>'
  };
  var LIFE = 4600, MAXV = 3, list = [], hovering = false;
  var layout = function () {
    var n = list.length;
    list.forEach(function (o, i) {
      var d = n - 1 - i; o.depth = d;
      if (o.dragging) return;
      o.el.style.transform = 'translateY(' + (-d * 11) + 'px) scale(' + (1 - d * 0.055) + ')';
      o.el.style.opacity = d >= MAXV ? 0 : 1 - d * 0.22;
      o.el.style.zIndex = 50 - d;
      o.el.setAttribute('aria-hidden', d >= MAXV ? 'true' : 'false');
      o.el.querySelector('.toast__x').tabIndex = d === 0 ? 0 : -1;
    });
    list.filter(function (o) { return o.depth >= MAXV + 1; }).forEach(function (o) { remove(o); });
  };
  var remove = function (o, dir) {
    if (o.gone) return;
    o.gone = true; if (o.bar) o.bar.cancel();
    var el = o.el;
    el.classList.remove('is-drag');
    if (dir) { el.style.transition = 'transform .24s cubic-bezier(.3,.7,.4,1), opacity .2s linear'; el.style.transform = 'translateX(' + dir * (stack.clientWidth + 60) + 'px) rotate(' + dir * 6 + 'deg)'; }
    else el.style.transform += ' translateY(14px) scale(.97)';
    el.style.opacity = 0; el.style.pointerEvents = 'none';
    list = list.filter(function (x) { return x !== o; });
    setTimeout(function () { el.remove(); }, 300);
    layout();
  };
  var drag = function (o) {
    var el = o.el, x0 = 0, dx = 0, lastX = 0, lastT = 0, v = 0, pid = null;
    el.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.toast__x') || o.depth !== 0 || o.gone) return;
      pid = e.pointerId; el.setPointerCapture(pid);
      x0 = lastX = e.clientX; lastT = performance.now(); dx = 0; v = 0;
      o.dragging = true; el.classList.add('is-drag'); if (o.bar) o.bar.pause();
    });
    el.addEventListener('pointermove', function (e) {
      if (e.pointerId !== pid) return;
      dx = e.clientX - x0;
      var now = performance.now(); v = (e.clientX - lastX) / Math.max(1, now - lastT); lastX = e.clientX; lastT = now;
      var w = el.offsetWidth;
      el.style.transform = 'translateX(' + dx + 'px) rotate(' + (dx / w * 4) + 'deg)';
      el.style.opacity = Math.max(0.15, 1 - Math.abs(dx) / w);
    });
    var end = function (e) {
      if (e.pointerId !== pid) return;
      pid = null; o.dragging = false;
      if (Math.abs(dx) > el.offsetWidth * 0.32 || Math.abs(v) > 0.55) { remove(o, Math.sign(dx || v) || 1); return; }
      el.classList.remove('is-drag'); if (o.bar && !hovering) o.bar.play(); layout();
    };
    el.addEventListener('pointerup', end); el.addEventListener('pointercancel', end);
  };
  var toast = function (ic, t, s) {
    var el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML = '<span class="toast__ic"><svg viewBox="0 0 24 24" aria-hidden="true">' + ICO[ic] + '</svg></span><span class="toast__tx"><b></b><span></span></span><button class="toast__x" type="button"><svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2 2l10 10M12 2 2 12"/></svg></button><span class="toast__bar" aria-hidden="true"></span>';
    el.querySelector('b').textContent = t; el.querySelector('.toast__tx span').textContent = s;
    el.querySelector('.toast__x').setAttribute('aria-label', 'Zamknij komunikat: ' + t);
    el.style.transition = 'none'; el.style.transform = 'translateY(115%) scale(.96)'; el.style.opacity = 0;
    stack.appendChild(el);
    var o = { el: el, depth: 0 };
    list.push(o); void el.offsetWidth; el.style.transition = '';
    o.bar = el.querySelector('.toast__bar').animate([{ transform: 'scaleX(1)' }, { transform: 'scaleX(0)' }], { duration: LIFE, easing: 'linear', fill: 'forwards' });
    o.bar.onfinish = function () { remove(o); };
    if (hovering) o.bar.pause();
    el.querySelector('.toast__x').addEventListener('click', function () { remove(o); });
    drag(o); layout();
    tsr.textContent = ''; setTimeout(function () { tsr.textContent = t + '. ' + s; }, 30);
  };
  stack.addEventListener('pointerover', function (e) { if (e.pointerType !== 'mouse' || hovering) return; hovering = true; list.forEach(function (o) { if (o.bar) o.bar.pause(); }); });
  stack.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'mouse') return; hovering = false; list.forEach(function (o) { if (!o.dragging && o.bar) o.bar.play(); }); });

  /* ---------- Oferta: wybór części 1, części 2 albo pakietu (przycisk, cena i lista zmieniają się razem) ---------- */
  (function () {
    var offer = $('[data-offer]'); if (!offer) return;
    var radios = $$('input[name="pick"]', offer); if (!radios.length) return;
    var btn = $('[data-of-buy]', offer), name = $('[data-of-name]', offer), type = $('[data-of-type]', offer), bname = $('[data-of-btn]', offer);
    var apply = function (r) {
      var v = r.value; offer.setAttribute('data-pick', v);
      name.innerHTML = r.getAttribute('data-title'); type.textContent = r.getAttribute('data-type');
      $$('[data-of-price]', offer).forEach(function (el) { el.textContent = r.getAttribute('data-price'); });
      $$('.checks[data-for]', offer).forEach(function (ul) { ul.hidden = ul.getAttribute('data-for') !== v; });
      ['data-href', 'data-price', 'data-name'].forEach(function (a) { btn.setAttribute(a, r.getAttribute(a)); });
      if (bname && r.getAttribute('data-btn')) bname.textContent = r.getAttribute('data-btn');
    };
    radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) apply(r); }); });
    var on = radios.filter(function (r) { return r.checked; })[0]; if (on && on.value !== 'tr') apply(on);
    $$('[data-pick-go]').forEach(function (a) {
      a.addEventListener('click', function () {
        var r = radios.filter(function (x) { return x.value === a.getAttribute('data-pick-go'); })[0];
        if (r && !r.checked) { r.checked = true; apply(r); }
      });
    });
  })();

  /* ---------- Zgoda przy zakupie: jedno zaznaczenie obowiązuje dla wszystkich przycisków; zapis w zamówieniu jako atrybut koszyka ---------- */
  var AGREE_TXT = 'Klient zażądał natychmiastowego dostarczenia treści cyfrowej i przyjął do wiadomości utratę prawa odstąpienia od umowy';
  $$('[data-agree]').forEach(function (c) {
    c.addEventListener('change', function () {
      $$('[data-agree]').forEach(function (o) { o.checked = c.checked; });
      if (c.checked) $$('.agree__err').forEach(function (e) { e.hidden = true; });
    });
  });
  // /cart/{wariant}:1 → koszyk przez Ajax API (z atrybutem zgody), potem płatność.
  // Przy błędzie: koszyk /cart, gdzie jest to samo pole zgody (audyt 2026-10-22, R-06). Gdy produkt nie trafił jeszcze do koszyka,
  // /cart/add?id=…&quantity=1 dodaje go i przekierowuje do /cart; gdy już jest w koszyku, wystarczy /cart.
  var goCheckout = function (href) {
    var m = /\/cart\/(\d+):1/.exec(href);
    if (!m) { location.assign(href); return; }
    var toCart = '/cart/add?id=' + m[1] + '&quantity=1';
    if (!window.fetch) { location.assign(toCart); return; }
    var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var stamp = new Date().toISOString();
    fetch('/cart/clear.js', { method: 'POST', headers: J })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: [{ id: +m[1], quantity: 1 }] }) }); })
      .then(function (r) { if (!r.ok) throw 0; toCart = '/cart'; return fetch('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ attributes: { 'Zgoda na dostarczenie': AGREE_TXT, 'Zgoda – czas': stamp } }) }); })
      .then(function (r) { if (!r.ok) throw 0; location.assign('/checkout'); })
      .catch(function () { location.assign(toCart); });
  };
  // ?wybor=t2|pakiet|tr (link z darmowego rozdziału) zaznacza właściwą opcję w ofercie
  (function () {
    var w = /[?&]wybor=(\w+)/.exec(location.search); if (!w) return;
    var r = $('input[name="pick"][value="' + w[1] + '"]'); if (!r) return;
    r.checked = true; r.dispatchEvent(new Event('change'));
  })();

  /* ---------- Kup teraz: zgoda, potem płatność Shopify (data-href = /cart/{wariant}:1), bez animacji ---------- */
  $$('[data-buy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn._busy) return;
      // zgoda na natychmiastowe dostarczenie treści cyfrowej (art. 38 ust. 1 pkt 13 ustawy o prawach konsumenta): bez niej nie ma zakupu
      var box = btn.closest('.buy'), ag = box && $('[data-agree]', box), agErr = box && $('.agree__err', box);
      if (ag && !ag.checked) { if (agErr) agErr.hidden = false; ag.focus(); return; }
      var href = btn.getAttribute('data-href') || '#oferta';
      if (href.charAt(0) === '#') { var t = $(href); if (t) { t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' }); t.focus && t.focus(); } return; }
      btn._busy = true; btn.setAttribute('aria-disabled', 'true');
      goCheckout(href);
      // gdyby przejście się nie udało (np. powrót przyciskiem „wstecz”), przycisk znów działa
      setTimeout(function () { btn._busy = false; btn.removeAttribute('aria-disabled'); }, 4000);
    });
  });
  addEventListener('pageshow', function () { $$('[data-buy]').forEach(function (b) { b._busy = false; b.removeAttribute('aria-disabled'); }); });

  /* ---------- Scena z książki: rozmowa w 6 sekund ---------- */
  var msgs = $('[data-msgs]'), status = $('[data-status]'), later = $('[data-later]');
  if (msgs) (function () { /* na stronie części 2 sceny nie ma */
  var CHAT = [['m', 'Jesteś już?', '20:47'], ['j', 'Jeszcze dwa przystanki', '20:49'], ['m', 'Napisz, jak dojedziesz', '20:49', 1], ['j', 'Jestem. Dziękuję za kurtkę i za kawę', '21:02'], ['m', 'Dziękuję za spacer. Chcę więcej takich wtorków', '21:02']];
  /* oś czasu (ms): pisze… → wiadomość; całość ok. 6 s */
  var PLAN = [[150, 'type'], [750, 0], [1450, 1], [2050, 'type'], [2700, 2], [3600, 3], [4250, 'type'], [5000, 4], [5600, 'read'], [6000, 'later']];
  var chatT = [];
  var bubble = function (m) {
    var li = document.createElement('li');
    li.className = 'bub' + (m[0] === 'j' ? ' me' : '') + (m[3] ? ' key' : '');
    li.textContent = m[1];
    var t = document.createElement('time'); t.textContent = m[2]; li.appendChild(t);
    return li;
  };
  var chatReset = function () { chatT.forEach(clearTimeout); chatT = []; msgs.innerHTML = '<li class="day">wtorek</li>'; later.classList.add('is-wait'); status.textContent = 'w sieci'; };
  var chatPlay = function () {
    chatReset();
    if (RM) { CHAT.forEach(function (m) { msgs.appendChild(bubble(m)); }); later.classList.remove('is-wait'); return; }
    var dots = null;
    PLAN.forEach(function (p) {
      chatT.push(setTimeout(function () {
        if (p[1] === 'type') { dots = document.createElement('li'); dots.className = 'bub dots'; dots.innerHTML = '<i></i><i></i><i></i>'; msgs.appendChild(dots); status.textContent = 'pisze…'; return; }
        if (p[1] === 'read') { var r = document.createElement('li'); r.className = 'read'; r.textContent = 'Odczytano 21:03'; msgs.appendChild(r); return; }
        if (p[1] === 'later') { later.classList.remove('is-wait'); return; }
        var m = CHAT[p[1]];
        if (dots && m[0] === 'm') { dots.remove(); dots = null; }
        status.textContent = 'w sieci';
        msgs.appendChild(bubble(m));
      }, p[0]));
    });
  };
  $('[data-replay]').addEventListener('click', chatPlay);
  onView($('.phone'), chatPlay, 0.6);
  })();

  /* ---------- Narzędzie od razu: wejście kart; w cz. 2 działający minutnik 20 minut (nic nie jest zapisywane ani wysyłane) ---------- */
  (function () {
    var tq = $('.tq'); if (!tq) return;
    if (RM || !('IntersectionObserver' in window)) tq.classList.add('is-in');
    else onView(tq, function () { tq.classList.add('is-in'); }, 0.2);
    var box = $('[data-tq-timer]'); if (!box) return;
    var T = 20 * 60, btn = $('[data-tq-btn]', box), out = $('[data-tq-time]', box), end = 0, left = T, iv = 0;
    var show = function () {
      var m = Math.floor(left / 60), s = left % 60;
      out.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      box.style.setProperty('--tq-o', (1 - left / T).toFixed(4));
    };
    var tick = function () {
      left = Math.max(0, Math.round((end - Date.now()) / 1000)); show();
      if (!left) {
        clearInterval(iv); iv = 0; box.classList.add('is-done');
        out.textContent = 'Czego teraz potrzebujesz?'; btn.textContent = 'Jeszcze raz';
        if (navigator.vibrate) navigator.vibrate([200, 100, 200]);
      }
    };
    btn.addEventListener('click', function () {
      if (iv) { clearInterval(iv); iv = 0; btn.textContent = 'Wznów'; return; }
      if (!left || box.classList.contains('is-done')) { left = T; box.classList.remove('is-done'); }
      end = Date.now() + left * 1000; iv = setInterval(tick, 1000); btn.textContent = 'Pauza'; tick();
    });
    show();
  })();

  /* ---------- #12 Karta editorial: przewijanie steruje obrotem i rozłożeniem ---------- */
  var ed = $('[data-ed]'), sc = ed && $('[data-scrolly]', ed);
  if (ed) {
  var native = window.CSS && CSS.supports('animation-timeline: view()') && CSS.supports('animation-range: contain 0% contain 100%');
  if (RM) { ed.classList.add('js', 'rm'); ed.style.setProperty('--p', '1'); }
  else if (native) ed.classList.add('sd');
  else {
    ed.classList.add('js');
    var eraf = 0, ecur = -1;
    var eupd = function () { eraf = 0; var r = sc.getBoundingClientRect(), span = r.height - innerHeight, p = clamp(-r.top / span, 0, 1); if (Math.abs(p - ecur) > 0.0005) { ecur = p; ed.style.setProperty('--p', p.toFixed(4)); } };
    var ereq = function () { if (!eraf) eraf = requestAnimationFrame(eupd); };
    addEventListener('scroll', ereq, { passive: true }); addEventListener('resize', ereq); eupd();
  }
  }

  /* ---------- #20 Pole e-mail = darmowy rozdział (formularz klienta Shopify z tagiem rozdzial-1 albo tesknie-rozdzial-3) ---------- */
  var form = $('[data-ef]'), inp = $('.ef__in', form), fld = $('.ef__f', form), err = $('.ef__err', form), gob = $('.ef__go', form), env = $('.ef__env', form), flap = $('.ef__flap', form), fdone = $('.ef__done', form);
  var RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/, busy = false;
  var valid = function () { return RE.test(inp.value.trim()); };
  var clearErr = function () { form.classList.remove('is-err'); inp.setAttribute('aria-invalid', 'false'); err.textContent = ''; };
  var showErr = function () {
    var v = inp.value.trim();
    err.textContent = !v ? 'Wpisz adres e-mail.' : v.indexOf('@') < 0 ? 'Brakuje znaku „@”.' : 'Sprawdź końcówkę adresu, np. „.pl”.';
    form.classList.add('is-err'); inp.setAttribute('aria-invalid', 'true');
    if (!RM) fld.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(5px)' }, { transform: 'translateX(-3.5px)' }, { transform: 'translateX(2px)' }, { transform: 'translateX(0)' }], { duration: 300, easing: 'cubic-bezier(.36,.07,.19,.97)' });
  };
  // Wybór rozdziału (część 1 albo część 2): tag klienta, napisy i okładka zmieniają się razem; wybór zapamiętany na powrót z Shopify
  var frs = $$('input[name="fr"]', form), FRK = 'ch:fr';
  var frSet = function (r) {
    $('[data-fr-tag]', form).value = r.getAttribute('data-tag');
    $('[data-fr-lead]', form).textContent = r.getAttribute('data-lead');
    $('[data-fr-btn]', form).textContent = r.getAttribute('data-btn');
    var img = $('[data-fr-img]'); if (img) img.src = r.getAttribute('data-img');
    ['m1', 'm2', 'm3'].forEach(function (k) { var el = $('[data-fr-' + k + ']'); if (el) el.textContent = r.getAttribute('data-' + k); });
  };
  frs.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) frSet(r); }); });
  var frPick = function () { return frs.filter(function (r) { return r.checked; })[0]; };
  if (frPick() && frPick() !== frs[0]) frSet(frPick());
  inp.addEventListener('input', function () { var ok = valid(); form.classList.toggle('is-ok', ok); if (ok) clearErr(); });
  inp.addEventListener('blur', function () { if (inp.value.trim() && !valid()) showErr(); });
  var pass = false;
  form.addEventListener('submit', function (e) {
    // drugie wysłanie (po animacji) idzie normalnie, żeby hCaptcha Shopify dołożyła swój token
    if (pass) return;
    e.preventDefault();
    if (busy) return;
    if (!valid()) { showErr(); inp.focus(); return; }
    busy = true;
    gob.style.width = gob.offsetWidth + 'px'; void gob.offsetWidth;
    form.classList.add('is-send'); inp.blur();
    var D = RM ? 0 : 1;
    setTimeout(function () {
      if (!D) return;
      env.animate([{ opacity: 0, transform: 'scale(.5)' }, { opacity: 1, transform: 'scale(1.08)', offset: 0.7 }, { opacity: 1, transform: 'scale(1)' }], { duration: 220, easing: 'ease-out', fill: 'forwards' });
      flap.animate([{ transform: 'scaleY(-1)' }, { transform: 'scaleY(1)' }], { duration: 180, delay: 150, easing: 'cubic-bezier(.5,0,.3,1)', fill: 'forwards' });
      env.animate([{ transform: 'translate(0,0) rotate(0) scale(1)', opacity: 1 }, { transform: 'translate(-4px,5px) rotate(4deg) scale(.96)', opacity: 1, offset: 0.2, easing: 'cubic-bezier(.5,0,.8,.4)' }, { transform: 'translate(150px,-130px) rotate(-16deg) scale(.6)', opacity: 0 }], { duration: 480, delay: 330, easing: 'cubic-bezier(.4,0,.9,.5)', fill: 'forwards' });
    }, 220 * D);
    var fp = frPick(); try { sessionStorage.setItem(FRK, fp ? fp.value : 'r1'); } catch (x) {}
    // zgoda na maile z fragmentami zapisana jako tag; formularz Shopify i tak oznacza adres jako zapisany, więc seria maili wysyła tylko do tagu zgoda-maile
    var tg = $('[data-fr-tag]', form), mk = $('[data-mk]', form);
    tg.value = tg.value.split(',')[0] + (mk && mk.checked ? ',zgoda-maile' : '');
    var sent = false, send = function () {
      if (sent) return; sent = true; pass = true;
      if (form.requestSubmit) form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form);
    };
    setTimeout(function () {
      // bez tokenu hCaptcha Shopify odrzuca zapis („Invalid CAPTCHA token”), więc formularz podpinamy przez Shopify.captcha.protect
      var C = window.Shopify && window.Shopify.captcha;
      if (C && C.protect) { setTimeout(send, 8000); try { C.protect(form, send); } catch (x) { send(); } } else send();
    }, 820 * D + 20);
  });
  // Shopify po zapisie wraca na tę stronę z ?customer_posted=true
  if (/[?&]customer_posted=true/.test(location.search)) {
    var fv = 'r1'; try { fv = sessionStorage.getItem(FRK) || 'r1'; } catch (x) {}
    var fr = frs.filter(function (r) { return r.value === fv; })[0];
    if (fr) { fr.checked = true; frSet(fr); }
    var fName = fr ? fr.getAttribute('data-done') : 'Rozdział 1', fPage = fr ? fr.getAttribute('data-page') : '/pages/rozdzial-1';
    fdone.innerHTML = '<b>✓ Gotowe.</b> ' + fName + ' jest już dla Ciebie: <a href="' + fPage + '">czytaj teraz</a>. Link przyjdzie też mailem.';
    form.classList.add('is-ok', 'is-send', 'is-sent');
    toast('mail', fName + ' jest gotowy', 'Link przyjdzie też mailem. Jeśli najpierw dostaniesz prośbę o potwierdzenie adresu, kliknij ją. Sprawdź też Spam i Oferty.');
    setTimeout(function () { var r = $('#rozdzial'); if (r) r.scrollIntoView({ block: 'center' }); }, 60);
  }
  /* ---------- Przycisk w hero i pasek na dole: przejście do oferty (tam wybór książki i zgoda) ---------- */
  var offerSec = $('#oferta');
  var toOffer = function (smooth) {
    if (!offerSec) return;
    offerSec.scrollIntoView({ behavior: smooth && !RM ? 'smooth' : 'auto', block: 'start' });
    var h = $('#of-t'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  };
  $$('[data-go-offer]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); toOffer(true); });
  });

  /* ---------- Strona produktu (/products/…): zaznacz w ofercie właściwą książkę albo pakiet ---------- */
  (function () {
    var offer = $('[data-offer]'), h = offer && offer.getAttribute('data-product'); if (!h) return;
    var v = h === 'tesknie-ale-nie-wracam' ? 't2' : h.indexOf('pakiet') === 0 ? 'pakiet' : 'tr';
    var r = $('input[name="pick"][value="' + v + '"]'); if (!r || /[?&]wybor=/.test(location.search)) return;
    r.checked = true; r.dispatchEvent(new Event('change'));
    // pakiet: hero opowiada o części 1, więc od razu pokazujemy ofertę (część 2 ma własny początek strony)
    if (v === 'pakiet' && !location.hash) setTimeout(function () { toOffer(false); }, 60);
  })();

  /* ---------- Przyklejony pasek zakupu (telefon): widoczny poza hero i poza ofertą ---------- */
  (function () {
    var bar = $('[data-sbar]'); if (!bar || !('IntersectionObserver' in window) || !offerSec) return;
    var nm = $('[data-sbar-name]', bar), pr = $('[data-sbar-price]', bar), im = $('[data-sbar-img]', bar);
    var sync = function () {
      var r = $('input[name="pick"]:checked'); if (!r) return;
      nm.textContent = r.getAttribute('data-name'); pr.textContent = r.getAttribute('data-price');
      var src = bar.getAttribute('data-img-' + r.value) || bar.getAttribute('data-img-tr'); if (src) im.src = src;
    };
    $$('input[name="pick"]').forEach(function (r) { r.addEventListener('change', sync); }); sync();
    var vis = { hero: true, offer: false, foot: false }, typing = false;
    var upd = function () {
      var on = !vis.hero && !vis.offer && !vis.foot && !typing;
      if (on) bar.hidden = false;
      bar.classList.toggle('is-on', on);
      bar.inert = !on;
      if (on) bar.removeAttribute('aria-hidden'); else bar.setAttribute('aria-hidden', 'true');
    };
    var watch = function (el, k) {
      if (!el) return;
      new IntersectionObserver(function (en) { vis[k] = en[0].isIntersecting; upd(); }, { threshold: 0 }).observe(el);
    };
    watch($('#start'), 'hero'); watch(offerSec, 'offer'); watch($('.foot'), 'foot');
    // przy wpisywaniu e-maila pasek nie zasłania pola
    document.addEventListener('focusin', function (e) { if (e.target.matches('input[type="email"]')) { typing = true; upd(); } });
    document.addEventListener('focusout', function () { typing = false; upd(); });
  })();

  /* ---------- Szybkie wyjście: zastępuje stronę w historii, więc „wstecz” nie wraca do sklepu ---------- */
  $$('[data-exit]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); try { sessionStorage.clear(); } catch (x) {} location.replace(a.href); });
  });

  /* ---------- Ustawienia cookies: panel zgód z banera Shopify, bez banera strona Cookies ---------- */
  $$('[data-cookie-prefs]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
      else location.href = '/pages/cookies';
    });
  });
  /* ---------- Scena „Nitki”: pytania przyczepiają się, napinają i pękają (cykl 5,4 s, w pętli, dopóki scena jest na ekranie (24.10: zatrzymanie na ostatniej klatce wyglądało jak zacięcie)) ---------- */
  var nst = $('[data-nit]');
  if (nst) (function () {
    var st=nst,cv=st.querySelector('canvas'),cx=cv.getContext('2d');
    var W=0,H=0,dpr=1,raf=0,t0=0,last=0,tau=0,trail=[],sparks=[],snapped=false,ring=0,heldK=0,loopT=0,plays=0,MAXP=Infinity;
    var TH=[{a:[0,.24],l:'gdzie jesteś'},{a:[.26,0],l:'z kim'},{a:[.8,0],l:'o której'},{a:[1,.52],l:'po co'}],AT=[520,1000,1480,1960],SNAP=3550,CYC=5400;
    function size(){var w=st.clientWidth,h=st.clientHeight;dpr=Math.min(2,window.devicePixelRatio||1);
      if(w!==W||h!==H||cv.width!==Math.round(w*dpr)){W=w;H=h;cv.width=Math.round(W*dpr);cv.height=Math.round(H*dpr)}cx.setTransform(dpr,0,0,dpr,0,0)}
    function cl(x){return x<0?0:x>1?1:x}
    function eio(u){u=cl(u);return u<.5?4*u*u*u:1-Math.pow(-2*u+2,3)/2}
    function eo(u){u=cl(u);return 1-Math.pow(1-u,3)}
    function C(){return[W/2,124]}
    function free(T){var ax=W/2-40;return[W/2+ax*(.68*Math.sin(1.15*T+.3)+.32*Math.sin(2.4*T+1.1)),122+82*(.62*Math.sin(1.75*T+.6)+.38*Math.sin(.95*T+2.2))]}
    function qp(a,c,b,u){var v=1-u;return[v*v*a[0]+2*v*u*c[0]+u*u*b[0],v*v*a[1]+2*v*u*c[1]+u*u*b[1]]}
    function tcol(k,a){return'rgba('+(200+26*k|0)+','+(190-86*k|0)+','+(220-94*k|0)+','+a.toFixed(3)+')'}
    function frame(now){raf=requestAnimationFrame(frame);size();var t=now-t0,dt=Math.min(40,now-last);last=now;draw(t,dt)}
    function draw(t,dt){
      cx.clearRect(0,0,W,H);
      var c=C(),ten=TH.map(function(h,i){return eio((t-AT[i]-260)/900)}),k=0;ten.forEach(function(x){k+=x});k/=4;
      if(t<SNAP)heldK=k;else heldK=1-eio((t-SNAP)/650);
      var spd=t<SNAP?Math.max(.06,1-.95*k):1+1.4*Math.max(0,1-(t-SNAP)/1200);
      tau+=dt/1000*spd;
      var f=free(tau),hk=Math.pow(heldK,1.15),d=[f[0]+(c[0]-f[0])*hk,f[1]+(c[1]-f[1])*hk];
      if(t<SNAP&&k>.98){d[0]+=Math.sin(t*.09)*.6;d[1]+=Math.cos(t*.11)*.6}
      if(!snapped&&t>=SNAP){snapped=true;ring=1;TH.forEach(function(h){h.br=h.mid||d;for(var s=0;s<16;s++){var a=Math.random()*Math.PI*2,v=.06+Math.random()*.22;sparks.push({x:h.br[0],y:h.br[1],vx:Math.cos(a)*v,vy:Math.sin(a)*v-.05,l:1,d:550+Math.random()*450,g:Math.random()<.5})}})}
      cx.lineCap='round';
      TH.forEach(function(h,i){var A=[h.a[0]*W,h.a[1]*H],ts=t-AT[i];if(ts<0)return;
        if(t<SNAP){var sh=eo(ts/260),tip=[A[0]+(d[0]-A[0])*sh,A[1]+(d[1]-A[1])*sh],len=Math.hypot(tip[0]-A[0],tip[1]-A[1]),
          sl=1-ten[i],sag=sl*Math.min(44,len*.3)+(ten[i]>.95?Math.sin(t*.06+i)*.8:0),
          cp=[(A[0]+tip[0])/2,(A[1]+tip[1])/2+sag];h.mid=qp(A,cp,tip,.5);
          cx.strokeStyle=tcol(ten[i],.14);cx.lineWidth=5;cx.beginPath();cx.moveTo(A[0],A[1]);cx.quadraticCurveTo(cp[0],cp[1],tip[0],tip[1]);cx.stroke();
          cx.strokeStyle=tcol(ten[i],.55+.4*ten[i]);cx.lineWidth=1.1+.5*ten[i];cx.stroke();
          var la=cl((ts-200)/300);if(la>0){var m=h.mid,dx=tip[0]-A[0],dy=tip[1]-A[1],nl=Math.hypot(dx,dy)||1,nx=-dy/nl,ny=dx/nl;if(ny>0){nx=-nx;ny=-ny}
            var lx=m[0]+nx*13,ly=m[1]+ny*13;cx.font='600 13px Figtree, system-ui, sans-serif';var tw=cx.measureText(h.l).width;
            lx=Math.max(tw/2+6,Math.min(W-tw/2-6,lx));ly=Math.max(14,ly);
            cx.globalAlpha=la;cx.textAlign='center';cx.textBaseline='middle';cx.lineJoin='round';cx.strokeStyle='rgba(10,8,14,.9)';cx.lineWidth=4;cx.strokeText(h.l,lx,ly);
            cx.fillStyle=tcol(ten[i],1);cx.fillText(h.l,lx,ly);cx.globalAlpha=1}}
        else{var u=(t-SNAP)/700;if(u>=1)return;var e=eo(u),B=h.br,g=e*e*40;
          var E=[B[0]+(A[0]-B[0])*e*.75,B[1]+(A[1]-B[1])*e*.75+g],cp1=[(A[0]+E[0])/2,(A[1]+E[1])/2+28*e];
          cx.strokeStyle=tcol(1-e,.8*(1-u));cx.lineWidth=1.2;cx.beginPath();cx.moveTo(A[0],A[1]);cx.quadraticCurveTo(cp1[0],cp1[1],E[0],E[1]);cx.stroke();
          var E2=[B[0]+(d[0]-B[0])*e,B[1]+(d[1]-B[1])*e+g*.5],cp2=[(E2[0]+d[0])/2,(E2[1]+d[1])/2+16*e];
          cx.strokeStyle=tcol(1-e,.7*(1-u)*(1-u));cx.beginPath();cx.moveTo(E2[0],E2[1]);cx.quadraticCurveTo(cp2[0],cp2[1],d[0],d[1]);cx.stroke()}});
      cx.globalCompositeOperation='lighter';
      for(var s=sparks.length-1;s>=0;s--){var p=sparks[s];p.l-=dt/p.d;if(p.l<=0){sparks.splice(s,1);continue}p.vy+=.00045*dt;p.x+=p.vx*dt;p.y+=p.vy*dt;
        cx.strokeStyle=p.g?'rgba(255,214,140,'+p.l.toFixed(3)+')':'rgba(255,170,185,'+p.l.toFixed(3)+')';cx.lineWidth=1.6;cx.beginPath();cx.moveTo(p.x,p.y);cx.lineTo(p.x-p.vx*28,p.y-p.vy*28);cx.stroke()}
      trail.push([d[0],d[1]]);if(trail.length>22)trail.shift();
      var free01=t>=SNAP?1:1-k;
      for(var j=1;j<trail.length;j++){var a=j/trail.length;cx.strokeStyle='rgba(212,175,103,'+(a*.35*free01).toFixed(3)+')';cx.lineWidth=a*5;cx.beginPath();cx.moveTo(trail[j-1][0],trail[j-1][1]);cx.lineTo(trail[j][0],trail[j][1]);cx.stroke()}
      if(ring>0){var rr=(1-ring)*90;cx.strokeStyle='rgba(255,226,170,'+(ring*.7).toFixed(3)+')';cx.lineWidth=2*ring;cx.beginPath();cx.arc(d[0],d[1],8+rr,0,7);cx.stroke();ring-=dt/600}
      var hold=t<SNAP?k:heldK,col=[255-60*hold|0,214-60*hold|0,140+40*hold|0],R=28-12*hold+(t>=SNAP?10*Math.max(0,ring):0);
      var gg=cx.createRadialGradient(d[0],d[1],0,d[0],d[1],R);gg.addColorStop(0,'rgba('+col+','+(.75-.3*hold).toFixed(3)+')');gg.addColorStop(1,'rgba('+col+',0)');
      cx.fillStyle=gg;cx.beginPath();cx.arc(d[0],d[1],R,0,7);cx.fill();cx.globalCompositeOperation='source-over';
      cx.fillStyle='rgba(255,246,228,'+(1-.35*hold).toFixed(3)+')';cx.beginPath();cx.arc(d[0],d[1],5.5-1.5*hold,0,7);cx.fill()}
    function stop(){cancelAnimationFrame(raf);raf=0;clearTimeout(loopT)}
    function play(){stop();size();tau=0;trail=[];sparks=[];snapped=false;ring=0;heldK=0;
      if(RM){draw(3200,0);return}
      if(plays>=MAXP)return;plays++;
      t0=last=performance.now();raf=requestAnimationFrame(frame);loopT=setTimeout(plays<MAXP?play:stop,CYC)}
    if(RM||!('IntersectionObserver' in window)){play();window.addEventListener('resize',function(){if(RM)play()});return}
    var vis=false;
    document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else if(vis&&!raf)play()});
    new IntersectionObserver(function(en){vis=en[0].isIntersecting;if(vis){if(!raf&&!document.hidden)play()}else if(raf)stop()},{threshold:.25}).observe(st);
  })();
})();

/* hero: dmuchawiec (nr 5, 22.10). Za „Toksycznymi Relacjami” opada popiół, zza „Tęsknię…” odlatują nasiona dmuchawca. Canvas za okładkami, pauza poza ekranem, wyłączone przy ograniczeniu ruchu. */
(function(){
  var box=document.querySelector('.hero__cover--two');
  if(!box||!window.requestAnimationFrame||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var imTR=box.querySelector('img[src*="okladka-ksiazka"]'),imTT=box.querySelector('img[src*="okladka-tesknie"]');
  if(!imTR||!imTT)return;
  var cv=document.createElement('canvas');cv.className='hero__fx';cv.setAttribute('aria-hidden','true');box.insertBefore(cv,box.firstChild);
  var c=cv.getContext('2d'),W=0,H=0,tr,tt,as=[],dn=[],accA=0,accD=0,t0=0,last=0,raf=0;
  function R(a,b){return a+Math.random()*(b-a)}
  function pick(a){return a[Math.floor(Math.random()*a.length)]}
  function life(p){return Math.sin(Math.PI*Math.max(0,Math.min(1,p)))}
  function size(){var b=cv.getBoundingClientRect(),d=Math.min(2,window.devicePixelRatio||1);W=b.width;H=b.height;cv.width=W*d;cv.height=H*d;c.setTransform(d,0,0,d,0,0);
    function rr(el){var r=el.parentNode.getBoundingClientRect();return{x:r.left-b.left,y:r.top-b.top,w:r.width,h:r.height}}
    tr=rr(imTR);tt=rr(imTT)}
  function edge(r,s){if(s==='l')return{x:r.x+R(0,r.w*.1),y:r.y+R(.1,.95)*r.h};if(s==='r')return{x:r.x+r.w-R(0,r.w*.1),y:r.y+R(.1,.95)*r.h};return{x:r.x+R(.15,.9)*r.w,y:r.y+R(0,r.h*.08)}}
  function step(arr,dt,draw){for(var i=arr.length-1;i>=0;i--){var p=arr[i];p.age+=dt;if(p.age>p.life){arr.splice(i,1);continue}draw(p)}}
  function frame(now){var dt=Math.min(.05,(now-last)/1000),t=(now-t0)/1000;last=now;c.clearRect(0,0,W,H);var k=tt.w/170;
    accA+=dt*(t<3?9:1.6);while(accA>=1){accA--;var e=edge(tr,pick(['l','t','l']));as.push({x:e.x-R(0,14),y:e.y,vx:R(-4,1.5),vy:R(4,10),s:R(.6,1.4)*k,ember:Math.random()<.18,age:0,life:R(5,8),ph:R(0,6)})}
    step(as,dt,function(p){p.x+=(p.vx+Math.sin(t*.8+p.ph)*3)*dt;p.y+=p.vy*dt;var a=life(p.age/p.life);c.fillStyle=p.ember?'rgba(255,140,70,'+(.75*a)+')':'rgba(150,140,160,'+(.55*a)+')';c.beginPath();c.arc(p.x,p.y,p.s,0,7);c.fill()});
    accD+=dt*(t<3?3:.5);while(accD>=1){accD--;var f=edge(tt,pick(['r','t','r']));dn.push({x:f.x,y:f.y,vx:R(7,17),vy:R(-13,-5),rot:R(-.4,.4),age:0,life:R(8,12),ph:R(0,6),s:R(.55,.8)*k})}
    step(dn,dt,function(p){p.x+=p.vx*dt;p.y+=(p.vy+Math.sin(t*1.1+p.ph)*4)*dt;var a=.8*life(p.age/p.life);c.save();c.translate(p.x,p.y);c.rotate(p.rot+Math.sin(t*.7+p.ph)*.25);c.scale(p.s,p.s);c.strokeStyle='rgba(250,246,236,'+a+')';c.lineWidth=.9;c.beginPath();c.moveTo(0,0);c.lineTo(0,12);for(var i=0;i<9;i++){var an=-Math.PI/2+(i-4)*.32;c.moveTo(0,0);c.lineTo(Math.cos(an)*7,Math.sin(an)*7)}c.stroke();c.fillStyle='rgba(200,180,150,'+a+')';c.beginPath();c.arc(0,12,1.3,0,7);c.fill();c.restore()});
    raf=requestAnimationFrame(frame)}
  function start(){if(raf)return;size();last=performance.now();if(!t0)t0=last;raf=requestAnimationFrame(frame)}
  function stop(){if(raf)cancelAnimationFrame(raf);raf=0}
  var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){if(raf)size()},200)});
  var inView=true;
  document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else if(inView)start()});
  if('IntersectionObserver' in window)new IntersectionObserver(function(en){inView=en[0].isIntersecting;if(inView&&!document.hidden)start();else stop()}).observe(box);else start();
})();

/* opinie (24.10): przy 3+ opiniach karty przesuwają się od prawej do lewej (pauza po najechaniu, dotknięciu i przyciskiem). Ograniczony ruch = zwykła siatka. Drobinki są teraz wspólne dla całej strony (niżej). */
(function(){
  var sec=document.getElementById('opinie');
  if(!sec||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var ul=sec.querySelector('.ops');
  if(ul&&ul.children.length>=3){
    var vp=document.createElement('div');vp.className='ops-vp';ul.parentNode.insertBefore(vp,ul);vp.appendChild(ul);
    Array.prototype.slice.call(ul.children).forEach(function(li){var cl=li.cloneNode(true);cl.setAttribute('aria-hidden','true');cl.setAttribute('inert','');ul.appendChild(cl)});
    ul.classList.add('ops--run');
    var dur=function(){ul.style.setProperty('--ops-dur',Math.max(25,ul.scrollWidth/2/32)+'s')};dur();
    var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(dur,200)});
    var btn=document.createElement('button');btn.type='button';btn.className='ops__pause';btn.textContent='Zatrzymaj przewijanie';btn.setAttribute('aria-pressed','false');
    vp.parentNode.insertBefore(btn,vp.nextSibling);
    btn.addEventListener('click',function(){var on=vp.classList.toggle('ops--paused');btn.setAttribute('aria-pressed',on?'true':'false');btn.textContent=on?'Wznów przewijanie':'Zatrzymaj przewijanie'});
    var tp;vp.addEventListener('touchstart',function(){vp.classList.add('ops--paused');clearTimeout(tp)},{passive:true});
    vp.addEventListener('touchend',function(){clearTimeout(tp);tp=setTimeout(function(){if(btn.getAttribute('aria-pressed')!=='true')vp.classList.remove('ops--paused')},2500)},{passive:true});
  }
})();

/* drobinki w wybranych sekcjach (24.10): po uwadze Huberta „zasłaniają treść” nie latają już po całej stronie, tylko za treścią
   w sekcji darmowego rozdziału (#rozdzial) i zakupu (#oferta); na górze zostaje dmuchawiec przy okładkach (wyżej).
   Popiół płynie od lewej, nasiona dmuchawca odlatują od prawej. Płótno pod treścią (karty mają tło, więc nic nie przykrywają),
   działa tylko gdy sekcja jest widoczna, wyłączone przy ograniczeniu ruchu. */
(function(){
  if(!window.requestAnimationFrame||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  ['rozdzial','oferta'].forEach(function(id){
    var sec=document.getElementById(id);if(!sec)return;
    sec.classList.add('has-fx');
    var cv=document.createElement('canvas');cv.className='sec-fx';cv.setAttribute('aria-hidden','true');sec.insertBefore(cv,sec.firstChild);
    var c=cv.getContext('2d'),W=0,H=0,k=1,mob=false,as=[],dn=[],accA=0,accD=0,t0=0,last=0,raf=0;
    function R(a,b){return a+Math.random()*(b-a)}
    function life(p){return Math.sin(Math.PI*Math.max(0,Math.min(1,p)))}
    function size(){var b=sec.getBoundingClientRect(),d=Math.min(2,window.devicePixelRatio||1);W=b.width;H=b.height;cv.width=W*d;cv.height=H*d;c.setTransform(d,0,0,d,0,0);mob=W<700;k=mob?1.15:1.4}
    function step(arr,dt,draw){for(var i=arr.length-1;i>=0;i--){var p=arr[i];p.age+=dt;if(p.age>p.life||p.x<-40||p.x>W+40||p.y<-60||p.y>H+60){arr.splice(i,1);continue}draw(p)}}
    function ash(age){var top=Math.random()<.45;return{x:top?R(-10,W*.7):R(-14,-2),y:top?R(-14,-2):R(0,H*.85),vx:R(10,24),vy:R(6,14),s:R(.9,2)*k,ember:Math.random()<.12,age:age||0,life:R(12,20),ph:R(0,6)}}
    function seed(age){var side=Math.random()<.7;return{x:side?W+R(2,16):R(W*.35,W),y:side?R(H*.2,H):H+R(4,20),vx:R(-20,-9),vy:R(-12,-4),rot:R(-.4,.4),age:age||0,life:R(16,24),ph:R(0,6),s:R(.75,1.2)*k}}
    function frame(now){var dt=Math.min(.05,(now-last)/1000),t=(now-t0)/1000;last=now;c.clearRect(0,0,W,H);
      var area=Math.max(.6,Math.min(2.2,H/(mob?900:700)));
      accA+=dt*(mob?1.5:2.4)*area;while(accA>=1){accA--;as.push(ash())}
      step(as,dt,function(p){p.x+=(p.vx+Math.sin(t*.7+p.ph)*4)*dt;p.y+=p.vy*dt;var a=life(p.age/p.life);c.fillStyle=p.ember?'rgba(214,104,48,'+(.6*a)+')':'rgba(92,82,100,'+(.55*a)+')';c.beginPath();c.arc(p.x,p.y,p.s,0,7);c.fill()});
      accD+=dt*(mob?.5:.8)*area;while(accD>=1){accD--;dn.push(seed())}
      step(dn,dt,function(p){p.x+=(p.vx+Math.sin(t*.5+p.ph)*5)*dt;p.y+=(p.vy+Math.sin(t*1.1+p.ph)*4)*dt;var a=.85*life(p.age/p.life);
        c.save();c.translate(p.x,p.y);c.rotate(p.rot+Math.sin(t*.7+p.ph)*.28);c.scale(p.s,p.s);c.strokeStyle='rgba(120,98,74,'+a+')';c.lineWidth=.9;c.beginPath();c.moveTo(0,0);c.lineTo(0,12);
        for(var i=0;i<9;i++){var an=-Math.PI/2+(i-4)*.32;c.moveTo(0,0);c.lineTo(Math.cos(an)*7,Math.sin(an)*7)}c.stroke();c.fillStyle='rgba(140,110,80,'+a+')';c.beginPath();c.arc(0,12,1.3,0,7);c.fill();c.restore()});
      raf=requestAnimationFrame(frame)}
    function start(){if(raf)return;size();last=performance.now();if(!t0){t0=last;for(var i=0;i<(mob?8:12);i++){var p=ash(R(3,8));p.x=R(0,W);p.y=R(0,H);as.push(p)}for(var j=0;j<(mob?3:4);j++){var q=seed(R(4,9));q.x=R(W*.2,W);q.y=R(H*.1,H*.9);dn.push(q)}}raf=requestAnimationFrame(frame)}
    function stop(){if(raf)cancelAnimationFrame(raf);raf=0}
    var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){if(raf)size()},200)});
    var inView=false;
    document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else if(inView)start()});
    if('IntersectionObserver' in window)new IntersectionObserver(function(en){inView=en[0].isIntersecting;if(inView&&!document.hidden)start();else stop()}).observe(sec);else start();
  });
})();
